// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Download Our App - Exact Reference Design */
.download-app-section {
    position: relative;
    width: 100%;
    margin: 0 auto;
    background-color: #07090e;
    background-repeat: no-repeat;
    background-size: cover;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 100px 0px;
}

/* Bottom Complete Section Overlay - Figma Specs (Height: 264px, Top: 817px, Gradient: #171A20) */
.download-app-section::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 264px;
    background: linear-gradient(180deg, rgba(23, 26, 32, 0) 0%, #171A20 100%);
    pointer-events: none;
    z-index: 1;
}

.download-app-container {
    max-width: 1340px;
    width: 100%;
    display: grid;
    grid-template-columns: 1.4fr 0.6fr;
    gap: 20px;
    align-items: center;
    z-index: 2;
    position: relative;
}

/* Left Content Column */
.download-app-content {
    max-width: 90%;
    display: flex;
    flex-direction: column;
}

.download-app-title {
    font-size: 85px;
    font-weight: 700;
    letter-spacing: 0em;
    line-height: 118%;
    width: 100%;
    margin-bottom: 18px;
    background: linear-gradient(90deg, #fff 0%, #ba9d6c 50%, #D1AA67 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
}

.gold-gradient-text {
    background: linear-gradient(135deg, #ffffff 0%, #d1aa67 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    display: inline-block;
}

.download-app-subtitle {
    font-size: 26px;
    line-height: 1.55;
    color: rgb(255 255 255 / 60%);
    max-width: 100%;
    margin-bottom: 34px;
}

body.light_theme .download-app-section .step-text {
    color: #fff;
}

/* Glassmorphic Card */
.download-glass-card {
    background: rgb(255 255 255 / 5%);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(24px);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 24px;
    padding: 36px;
    max-width: 670px;
    width: 100%;
}

.tab-btn img {
    opacity: 0.6;
}

a.btn-app-store.appstorebtn img {
    filter: invert(1);
}

.tab-btn.active img {
    opacity: 1;
}

/* Tab Switcher */
.app-tab-nav {
    background: rgb(255 255 255 / 10%);
    border-radius: 50px;
    padding: 5px;
    display: flex;
    gap: 4px;
    margin-bottom: 32px;
    border: 1px solid rgb(255 255 255 / 6%);
}

.tab-btn {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 10px 16px;
    border-radius: 32px;
    border: none;
    background: transparent;
    color: #94a3b8;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.tab-btn:hover:not(.active) {
    color: #ffffff;
    background: rgba(255, 255, 255, 0.05);
}

.tab-btn.active {
    background: linear-gradient(180deg, rgba(209, 170, 103, 1) 0%, rgba(176, 124, 46, 1) 100%);
    color: #ffffff;
    font-weight: 600;
    box-shadow: inset 0 0.9px 0.9px rgba(255, 255, 255, 0.5);
}

/* Card Body Grid */
.card-body-grid {
    display: grid;
    grid-template-columns: 1fr 236px;
    gap: 26px;
    align-items: stretch;
}

.card-left-col {
    display: flex;
    flex-direction: column;
}

/* Download Buttons */
.download-buttons-group {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
}

.download-buttons-group a {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    border: none;
    padding: 13px 24px;
    border-radius: 14px;
    font-size: 15px;
    font-weight: 600;
    text-decoration: none;
    transition: all 0.2s ease;
}

.btn-google-play,
.btn-app-store {
    background: #ffffff;
    color: #0b0e14;
}

.btn-google-play:hover,
.btn-app-store:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 18px rgba(255, 255, 255, 0.2);
    color: #000000;
}

.btn-direct-apk {
    background: rgba(255, 255, 255, 0.10);
    color: #ffffff;
}

.btn-direct-apk:hover {
    background: rgba(255, 255, 255, 0.14);
    border-color: rgba(255, 255, 255, 0.25);
    transform: translateY(-2px);
    color: #ffffff;
}

/* Instruction Steps */
.instructions-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 8px;
    margin-bottom: 26px;
}

.step-item {
    display: flex;
    align-items: center;
    gap: 10px;
}

.step-icon-badge {
    width: 32px;
    height: 32px;
    min-width: 32px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.10);
    border: 1px solid rgb(209 170 103 / 20%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #d8a44c;
    flex-shrink: 0;
    -webkit-backdrop-filter: blur(4px);
            backdrop-filter: blur(4px);
}

.step-text {
    font-size: 15px;
    color: #fff;
    font-weight: 400;
}

.helper-note {
    font-size: 11px;
    color: #A1A1AA;
    line-height: 1.4;
    margin-top: 0px;
}

/* QR Code Card */
.card-qr-col {
    display: flex;
}

.qr-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.qr-box_scan {
    width: 100%;
    display: flex;
    /* align-items: end; */
    justify-content: end;
}

.qr-code-img {
    width: 234px;
    object-fit: contain;
    box-shadow: 0px 28px 57px -13px #000;
    border-radius: 26px;
}

.qr-caption {
    font-size: 13px;
    color: #D4D4D8;
    margin-top: -10px;
    text-align: center;
    line-height: 1.3;
    width: 100%;
}

/* Bottom Features Row */
.features-row {
    position: relative;
    display: flex;
    align-items: center;
    gap: 32px;
    margin-top: 24px;
    padding-top: 16px;
}

.features-row::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 630px;
    max-width: 100%;
    height: 0.84px;
    background: linear-gradient(90deg, #FFFFFF 58.17%, rgba(0, 0, 0, 0) 100%);
    opacity: 1;
}

.feature-item {
    display: flex;
    align-items: center;
    gap: 13px;
    color: #fff;
    font-size: 18px;
    font-weight: 300;
}

.feature-item span {
    display: inline-block;
    line-height: 1;
}

.feature-icon {
    color: #ffffff;
    flex-shrink: 0;
    display: block;
    width: 17px;
    height: 17px;
    transform: translateY(1.5px);
}

/* Right Column Mobile Graphic */
.download-app-visual {
    display: flex;
    align-items: center;
    justify-content: start;
    width: 100%;
}

.mobile-graphic-overlay {
    width: 325px;
    max-width: 100%;
    /* margin-left: 138px; */
    height: auto;
    object-fit: contain;
    filter: drop-shadow(0 30px 60px rgba(0, 0, 0, 0.75));
}

/* Responsive Breakpoints */

@media (max-width: 1550px) {

    .download-app-title {
        font-size: 60px;
    }

    .download-app-subtitle {
        font-size: 22px;
    }

}

@media (max-width: 1376px) {

    .download-app-title {
        font-size: 48px;
    }

    .download-app-subtitle {
        font-size: 18px;
    }

    .download-app-section {
        padding: 50px 0px;
    }

}


@media (max-width: 1100px) {


    .download-app-section {
        padding: 40px 0px;
        background-position: center;
    }

    .download-app-container {
        gap: 20px;
        max-width: 96%;
    }

    .feature-item {
        font-size: 16px;
    }

    .download-glass-card {
        max-width: 100%;
    }

    .download-app-title {
        font-size: 42px;
    }

    .download-app-visual {
        justify-content: center;
        min-height: 400px;
    }
}

@media (max-width: 991px) {

    .download-app-container {
        grid-template-columns: 1fr;
    }

    .download-app-title {
        font-size: 36px;
    }

    .download-app-content {
        max-width: 100%;
        text-align: center;
    }

    .helper-note {
        text-align: left;
    }

    .download-app-visual {
        justify-content: center;
        min-height: 100%;
        max-width: 240px;
        margin: 0 auto;
    }

    .features-row {
        justify-content: center;
    }

}

@media (max-width: 767px) {

    .download-app-section {
        padding: 30px 20px;
    }

    .download-app-title {
        font-size: 24px;
    }

    .download-app-subtitle {
        font-size: 15px;
        margin-bottom: 18px;
    }

    .download-glass-card {
        border-radius: 18px;
        padding: 22px;
    }

    .download-buttons-group a {
        padding: 10px 14px;
        border-radius: 8px;
        font-size: 13px;
        gap: 5px;
    }

    .download-buttons-group {
        justify-content: center;
    }

    .step-item {
        text-align: left;
    }

    .qr-box_scan {
        justify-content: center;
    }

    .feature-item {
        font-size: 15px;
    }

    .download-app-visual {
        max-width: 150px;
    }

    .card-body-grid {
        grid-template-columns: 1fr;
        gap: 20px;
    }

    .card-qr-col {
        justify-content: center;
    }

    .features-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
    }
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/FooterPages/downloadapp.css"],"names":[],"mappings":"AAEA,8CAA8C;AAC9C;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,4BAA4B;IAC5B,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA,iGAAiG;AACjG;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,aAAa;IACb,yEAAyE;IACzE,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,kCAAkC;IAClC,SAAS;IACT,mBAAmB;IACnB,UAAU;IACV,kBAAkB;AACtB;;AAEA,wBAAwB;AACxB;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,sEAAsE;IACtE,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,6DAA6D;IAC7D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA,sBAAsB;AACtB;IACI,iCAAiC;IACjC,2BAA2B;IAC3B,mCAAmC;IACnC,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA,iBAAiB;AACjB;IACI,kCAAkC;IAClC,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kDAAkD;AACtD;;AAEA;IACI,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,0FAA0F;IAC1F,cAAc;IACd,gBAAgB;IAChB,wDAAwD;AAC5D;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,2BAA2B;IAC3B,+CAA+C;IAC/C,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;IACvC,2BAA2B;IAC3B,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,qCAAqC;IACrC,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,cAAc;IACd,kCAA0B;YAA1B,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA,wBAAwB;AACxB;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,eAAe;IACf,cAAc;IACd,yEAAyE;IACzE,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,cAAc;IACd,WAAW;IACX,YAAY;IACZ,4BAA4B;AAChC;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,wBAAwB;IACxB,YAAY;IACZ,mBAAmB;IACnB,oDAAoD;AACxD;;AAEA,2BAA2B;;AAE3B;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;AAEA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;AAEJ;;;AAGA;;;IAGI;QACI,iBAAiB;QACjB,2BAA2B;IAC/B;;IAEA;QACI,SAAS;QACT,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,uBAAuB;QACvB,iBAAiB;IACrB;AACJ;;AAEA;;IAEI;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,gBAAgB;QAChB,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,uBAAuB;IAC3B;;AAEJ;;AAEA;;IAEI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;QAClB,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;AACJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');\n\n/* Download Our App - Exact Reference Design */\n.download-app-section {\n    position: relative;\n    width: 100%;\n    margin: 0 auto;\n    background-color: #07090e;\n    background-repeat: no-repeat;\n    background-size: cover;\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 100px 0px;\n}\n\n/* Bottom Complete Section Overlay - Figma Specs (Height: 264px, Top: 817px, Gradient: #171A20) */\n.download-app-section::after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 264px;\n    background: linear-gradient(180deg, rgba(23, 26, 32, 0) 0%, #171A20 100%);\n    pointer-events: none;\n    z-index: 1;\n}\n\n.download-app-container {\n    max-width: 1340px;\n    width: 100%;\n    display: grid;\n    grid-template-columns: 1.4fr 0.6fr;\n    gap: 20px;\n    align-items: center;\n    z-index: 2;\n    position: relative;\n}\n\n/* Left Content Column */\n.download-app-content {\n    max-width: 90%;\n    display: flex;\n    flex-direction: column;\n}\n\n.download-app-title {\n    font-size: 85px;\n    font-weight: 700;\n    letter-spacing: 0em;\n    line-height: 118%;\n    width: 100%;\n    margin-bottom: 18px;\n    background: linear-gradient(90deg, #fff 0%, #ba9d6c 50%, #D1AA67 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    color: transparent;\n}\n\n.gold-gradient-text {\n    background: linear-gradient(135deg, #ffffff 0%, #d1aa67 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    display: inline-block;\n}\n\n.download-app-subtitle {\n    font-size: 26px;\n    line-height: 1.55;\n    color: rgb(255 255 255 / 60%);\n    max-width: 100%;\n    margin-bottom: 34px;\n}\n\nbody.light_theme .download-app-section .step-text {\n    color: #fff;\n}\n\n/* Glassmorphic Card */\n.download-glass-card {\n    background: rgb(255 255 255 / 5%);\n    backdrop-filter: blur(20px);\n    -webkit-backdrop-filter: blur(24px);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 24px;\n    padding: 36px;\n    max-width: 670px;\n    width: 100%;\n}\n\n.tab-btn img {\n    opacity: 0.6;\n}\n\na.btn-app-store.appstorebtn img {\n    filter: invert(1);\n}\n\n.tab-btn.active img {\n    opacity: 1;\n}\n\n/* Tab Switcher */\n.app-tab-nav {\n    background: rgb(255 255 255 / 10%);\n    border-radius: 50px;\n    padding: 5px;\n    display: flex;\n    gap: 4px;\n    margin-bottom: 32px;\n    border: 1px solid rgb(255 255 255 / 6%);\n}\n\n.tab-btn {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 10px 16px;\n    border-radius: 32px;\n    border: none;\n    background: transparent;\n    color: #94a3b8;\n    font-size: 15px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.tab-btn:hover:not(.active) {\n    color: #ffffff;\n    background: rgba(255, 255, 255, 0.05);\n}\n\n.tab-btn.active {\n    background: linear-gradient(180deg, rgba(209, 170, 103, 1) 0%, rgba(176, 124, 46, 1) 100%);\n    color: #ffffff;\n    font-weight: 600;\n    box-shadow: inset 0 0.9px 0.9px rgba(255, 255, 255, 0.5);\n}\n\n/* Card Body Grid */\n.card-body-grid {\n    display: grid;\n    grid-template-columns: 1fr 236px;\n    gap: 26px;\n    align-items: stretch;\n}\n\n.card-left-col {\n    display: flex;\n    flex-direction: column;\n}\n\n/* Download Buttons */\n.download-buttons-group {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 20px;\n}\n\n.download-buttons-group a {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    border: none;\n    padding: 13px 24px;\n    border-radius: 14px;\n    font-size: 15px;\n    font-weight: 600;\n    text-decoration: none;\n    transition: all 0.2s ease;\n}\n\n.btn-google-play,\n.btn-app-store {\n    background: #ffffff;\n    color: #0b0e14;\n}\n\n.btn-google-play:hover,\n.btn-app-store:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 18px rgba(255, 255, 255, 0.2);\n    color: #000000;\n}\n\n.btn-direct-apk {\n    background: rgba(255, 255, 255, 0.10);\n    color: #ffffff;\n}\n\n.btn-direct-apk:hover {\n    background: rgba(255, 255, 255, 0.14);\n    border-color: rgba(255, 255, 255, 0.25);\n    transform: translateY(-2px);\n    color: #ffffff;\n}\n\n/* Instruction Steps */\n.instructions-list {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-top: 8px;\n    margin-bottom: 26px;\n}\n\n.step-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.step-icon-badge {\n    width: 32px;\n    height: 32px;\n    min-width: 32px;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.10);\n    border: 1px solid rgb(209 170 103 / 20%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #d8a44c;\n    flex-shrink: 0;\n    backdrop-filter: blur(4px);\n}\n\n.step-text {\n    font-size: 15px;\n    color: #fff;\n    font-weight: 400;\n}\n\n.helper-note {\n    font-size: 11px;\n    color: #A1A1AA;\n    line-height: 1.4;\n    margin-top: 0px;\n}\n\n/* QR Code Card */\n.card-qr-col {\n    display: flex;\n}\n\n.qr-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n}\n\n.qr-box_scan {\n    width: 100%;\n    display: flex;\n    /* align-items: end; */\n    justify-content: end;\n}\n\n.qr-code-img {\n    width: 234px;\n    object-fit: contain;\n    box-shadow: 0px 28px 57px -13px #000;\n    border-radius: 26px;\n}\n\n.qr-caption {\n    font-size: 13px;\n    color: #D4D4D8;\n    margin-top: -10px;\n    text-align: center;\n    line-height: 1.3;\n    width: 100%;\n}\n\n/* Bottom Features Row */\n.features-row {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 32px;\n    margin-top: 24px;\n    padding-top: 16px;\n}\n\n.features-row::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 630px;\n    max-width: 100%;\n    height: 0.84px;\n    background: linear-gradient(90deg, #FFFFFF 58.17%, rgba(0, 0, 0, 0) 100%);\n    opacity: 1;\n}\n\n.feature-item {\n    display: flex;\n    align-items: center;\n    gap: 13px;\n    color: #fff;\n    font-size: 18px;\n    font-weight: 300;\n}\n\n.feature-item span {\n    display: inline-block;\n    line-height: 1;\n}\n\n.feature-icon {\n    color: #ffffff;\n    flex-shrink: 0;\n    display: block;\n    width: 17px;\n    height: 17px;\n    transform: translateY(1.5px);\n}\n\n/* Right Column Mobile Graphic */\n.download-app-visual {\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    width: 100%;\n}\n\n.mobile-graphic-overlay {\n    width: 325px;\n    max-width: 100%;\n    /* margin-left: 138px; */\n    height: auto;\n    object-fit: contain;\n    filter: drop-shadow(0 30px 60px rgba(0, 0, 0, 0.75));\n}\n\n/* Responsive Breakpoints */\n\n@media (max-width: 1550px) {\n\n    .download-app-title {\n        font-size: 60px;\n    }\n\n    .download-app-subtitle {\n        font-size: 22px;\n    }\n\n}\n\n@media (max-width: 1376px) {\n\n    .download-app-title {\n        font-size: 48px;\n    }\n\n    .download-app-subtitle {\n        font-size: 18px;\n    }\n\n    .download-app-section {\n        padding: 50px 0px;\n    }\n\n}\n\n\n@media (max-width: 1100px) {\n\n\n    .download-app-section {\n        padding: 40px 0px;\n        background-position: center;\n    }\n\n    .download-app-container {\n        gap: 20px;\n        max-width: 96%;\n    }\n\n    .feature-item {\n        font-size: 16px;\n    }\n\n    .download-glass-card {\n        max-width: 100%;\n    }\n\n    .download-app-title {\n        font-size: 42px;\n    }\n\n    .download-app-visual {\n        justify-content: center;\n        min-height: 400px;\n    }\n}\n\n@media (max-width: 991px) {\n\n    .download-app-container {\n        grid-template-columns: 1fr;\n    }\n\n    .download-app-title {\n        font-size: 36px;\n    }\n\n    .download-app-content {\n        max-width: 100%;\n        text-align: center;\n    }\n\n    .helper-note {\n        text-align: left;\n    }\n\n    .download-app-visual {\n        justify-content: center;\n        min-height: 100%;\n        max-width: 240px;\n        margin: 0 auto;\n    }\n\n    .features-row {\n        justify-content: center;\n    }\n\n}\n\n@media (max-width: 767px) {\n\n    .download-app-section {\n        padding: 30px 20px;\n    }\n\n    .download-app-title {\n        font-size: 24px;\n    }\n\n    .download-app-subtitle {\n        font-size: 15px;\n        margin-bottom: 18px;\n    }\n\n    .download-glass-card {\n        border-radius: 18px;\n        padding: 22px;\n    }\n\n    .download-buttons-group a {\n        padding: 10px 14px;\n        border-radius: 8px;\n        font-size: 13px;\n        gap: 5px;\n    }\n\n    .download-buttons-group {\n        justify-content: center;\n    }\n\n    .step-item {\n        text-align: left;\n    }\n\n    .qr-box_scan {\n        justify-content: center;\n    }\n\n    .feature-item {\n        font-size: 15px;\n    }\n\n    .download-app-visual {\n        max-width: 150px;\n    }\n\n    .card-body-grid {\n        grid-template-columns: 1fr;\n        gap: 20px;\n    }\n\n    .card-qr-col {\n        justify-content: center;\n    }\n\n    .features-row {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 16px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
